// Obter URL do domínio frontend
const getFrontendDomain = (): string => {
  // Verificar se estamos em ambiente de teste
  if (typeof window === 'undefined') {
    return 'http://prodgy.ai'; // Fallback para testes
  }

  const domain = (window.ENV?.VITE_PRODGY_DOMAIN && window.ENV.VITE_PRODGY_DOMAIN !== '') 
    ? window.ENV.VITE_PRODGY_DOMAIN 
    : import.meta.env.VITE_PRODGY_DOMAIN;

  if (!domain) {
    console.warn('VITE_PRODGY_DOMAIN não está configurado. Usando window.location.origin como fallback.');
    console.warn('window.location.origin:', window.location?.origin);
    return window.location?.origin || 'http://localhost:3000';
  }

  // Remove trailing slash se presente
  return domain.endsWith('/') ? domain.slice(0, -1) : domain;
};

// Configuração do domínio
export const DOMAIN_CONFIG = {
  FRONTEND_DOMAIN: getFrontendDomain(),
  
  // Método para construir URL completa do webhook no frontend
  buildFrontendWebhookUrl: (webhookPath: string): string => {
    const cleanPath = webhookPath.startsWith('/') ? webhookPath : `/${webhookPath}`;
    return `${getFrontendDomain()}/api/webhook${cleanPath}`;
  },

  // Método para validar se uma URL é do frontend
  isFrontendUrl: (url: string): boolean => {
    return url.startsWith(getFrontendDomain());
  }
};